'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes.js');
var _ = require('underscore');
var PopupHelper = require('../../interactive/PopupHelper');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 弹出面板组件
 */
var SlidingDrawer = React.createClass({

  render: function () {
    var bgComp = this.props.items[0];
    var contentComp = this.props.items[1];
    var contentStyle = {padding: 0, opacity: this.props.popup ? 1 : 0, visibility: 'visible', left: 0, zIndex: 1};
    var bg = util.Color.setOpacity(bgComp.color, 0.4);
    styleHelper.StyleUtil(contentComp, contentStyle).bounds().background().border().base();
    var dom = <div
      key={this.props.controlID}
      id={this.props.controlID}
      className='component component-SlidingDrawer popup-control'
      style={{
        visibility : this.props.popup?'visible': 'hidden',
        zIndex : this.props.zOrder
      }}>
      <div id={this.props.controlID + '-background'}
           ref="background"
           className="background"
           style={{
             width : this.props.measureWidth || 0,
             height : this.props.measureHeight || 0,
             backgroundColor : this.props.isShowBackground?bg:0,
             pointerEvents : this.props.closeByClickMode === appTypes.PopupPanelClosePolicy.NONE ? 'auto' : 'none'
           }}></div>
      <div id={this.props.controlID + '-content'}
           className="content"
           ref="content"
           style={contentStyle}>
        {
          this.props.children
        }
      </div>
    </div>;
    return (dom);
  },

  componentDidMount: function () {
    this.doPopup();
    if(this.props.onOpened) {
      this.props.onOpened(this.props);
    }
  },

  componentDidUpdate: function () {
    this.doPopup();
  },

  doPopup: function () {
    PopupHelper.registerPopup(this);
    if (this.open) {
      this.open();
    }
    var dom = $(ReactDOM.findDOMNode(this));
    var content = $(ReactDOM.findDOMNode(this.refs.content));
    var background = $(ReactDOM.findDOMNode(this.refs.background));
    if (this.props.isPopupClosing && this.props.closePopup) {
      this.props.closePopup(dom, this.props, content, background);
    }
  }
});

module.exports = SlidingDrawer;



// WEBPACK FOOTER //
// ./src/views/Components/SlidingDrawer.jsx